<template>
  <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : repairRegistration.id > 0 ? '编辑' : '新建'"
      width="1300px"
      top="1vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="repairRegistration"
        :disabled="disabled"
        label-width="120px">
      <div class="title">原始信息</div>
      <div>
        <div class="vm-separate">
          <el-form-item v-if="repairRegistration.id > 0" prop="billNo" label="单据编号">
            <span>{{repairRegistration.billNo}}</span>
          </el-form-item>
          <el-form-item prop="creatorName" label="维修员">
            <span>{{repairRegistration.creatorName}}</span>
          </el-form-item>
          <div v-if="!repairRegistration.id"/>
          <div/>
        </div>
        <div class="vm-separate">
          <el-form-item prop="projectName" label="项目名称">
            <el-input
                v-model.trim="repairRegistration.projectName"
                placeholder="请输入项目名称"
                clearable/>
          </el-form-item>
          <el-form-item prop="projectName" label="电梯编号">
            <el-input
                v-model.trim="repairRegistration.elevatorNo"
                placeholder="请输入项目名称"
                clearable/>
          </el-form-item>
          <el-form-item prop="productName" label="产品名称" :rules="$rule.notNull">
            <el-input
                v-model.trim="repairRegistration.productName"
                placeholder="请输入产品名称"
                clearable/>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item prop="productModel" label="产品型号">
            <el-input
                v-model.trim="repairRegistration.productModel"
                placeholder="请输入产品型号"
                clearable/>
          </el-form-item>
          <el-form-item prop="productNo" label="物料号">
            <el-input
                v-model.trim="repairRegistration.productNo"
                placeholder="请输入物料号"
                clearable/>
          </el-form-item>
          <el-form-item prop="quantity" label="产品数量" :rules="$rule.notNull">
            <el-input
                v-model.number="repairRegistration.quantity"
                :placeholder="disabled ? '' : '请输入产品数量'"
                type="number"
                min="0"/>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item prop="afterSaleType" label="维修类型" :rules="$rule.notNull">
            <el-select v-model="repairRegistration.afterSaleType" :placeholder="disabled ? '' : '请选择维修类型'">
              <el-option value="更换"/>
              <el-option value="维修"/>
              <el-option value="回采"/>
              <el-option value="批量整改"/>
            </el-select>
          </el-form-item>
          <el-form-item prop="afterSaleOrderNo" label="售后单号">
            <el-input
                v-model.trim="repairRegistration.afterSaleOrderNo"
                :placeholder="disabled ? '' : '请输入售后单号'"
                clearable>
              <el-button slot="append" icon="el-icon-search" @click="afterSaleOrderNoChange"/>
            </el-input>
          </el-form-item>
          <el-form-item prop="partType" label="部件类型">
            <el-select v-model="repairRegistration.partType" :placeholder="disabled ? '' : '请选择部件类型'">
              <el-option value="整机"/>
              <el-option value="板卡"/>
              <el-option value="抱闸电源"/>
              <el-option value="操作器"/>
              <el-option value="IGBT模块"/>
              <el-option value="电容"/>
              <el-option value="电流传感器"/>
              <el-option value="线束"/>
              <el-option value="电子元件"/>
              <el-option value="其它器件"/>
              <el-option value="其它"/>
            </el-select>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item prop="customerName" label="客户名称">
            <el-input v-model="repairRegistration.customerName" readonly :placeholder="disabled ? '' : '请选择客户'">
              <el-button slot="append" icon="el-icon-search" @click="$refs.customerSelect.open()"/>
            </el-input>
          </el-form-item>
          <el-form-item prop="customerOrderNo" label="客户单号">
            <el-input
                v-model.trim="repairRegistration.customerOrderNo"
                :placeholder="disabled ? '' : '请输入客户单号'"
                clearable/>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item prop="productDate" label="生产日期">
            <el-date-picker
                v-model="repairRegistration.productDate"
                value-format="yyyy-MM-dd"
                type="date"
                clearable
                style="width: 100%"
                :placeholder="disabled ? '' : '选择生产日期'"/>
          </el-form-item>
          <el-form-item prop="backTime" label="退件日期">
            <el-date-picker
                v-model="repairRegistration.backTime"
                value-format="yyyy-MM-dd"
                type="date"
                clearable
                style="width: 100%"
                :placeholder="disabled ? '' : '退件日期'"/>
          </el-form-item>
          <el-form-item prop="deliveryDate" label="发货日期">
            <el-date-picker
                v-model="repairRegistration.deliveryDate"
                value-format="yyyy-MM-dd"
                type="date"
                clearable
                style="width: 100%"
                :placeholder="disabled ? '' : '选择发货日期'"
                @change="getSaleTime(repairRegistration.demandAfterSaleTime, repairRegistration.deliveryDate, 'saleTime')"/>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item prop="afterSaleExpired" label="售后过保">
            <el-switch
                v-model="repairRegistration.afterSaleExpired"
                :active-value="true"
                :inactive-value="false"
                active-text="是"
                inactive-text="否"/>
          </el-form-item>
          <el-form-item prop="needQualitySurvey" label="需要质量报告">
            <el-switch
                v-model="repairRegistration.needQualitySurvey"
                :active-value="true"
                :inactive-value="false"
                active-text="是"
                inactive-text="否"/>
          </el-form-item>
        </div>
        <el-form-item prop="siteDesc" label="现场描述">
          <el-input
              v-model.trim="repairRegistration.siteDesc"
              type="textarea"
              :placeholder="disabled ? '' : '请输入现场描述'"
              clearable
              autosize
              maxlength="300"
              show-word-limit/>
        </el-form-item>
      </div>
      <div v-if="repairRegistration.partType==='整机'" class="title">整机维修信息</div>
      <div v-else class="title">维修检测信息</div>
      <div v-if="repairRegistration.partType==='整机'">
        <div class="vm-separate">
          <el-form-item prop="receiveSn" label="实收序列号">
            <el-input
                v-model.trim="repairRegistration.receiveSn"
                :placeholder="disabled ? '' : '请输入实收序列号'"
                clearable/>
          </el-form-item>
          <el-form-item prop="receiveMaterialNo" label="实收物料号">
            <el-input
                v-model.trim="repairRegistration.receiveMaterialNo"
                :placeholder="disabled ? '' : '请输入实收物料号'"
                clearable
                @change="getMaterialName(repairRegistration.receiveMaterialNo, 'receiveMaterialName')"/>
          </el-form-item>
          <el-form-item prop="model" label="规格型号">
            <el-autocomplete
                v-model.trim="repairRegistration.model"
                style="width: 100%"
                clearable
                :fetch-suggestions="((queryString, cb) => {querySearch(queryString, cb, models)})"
                :placeholder="disabled ? '' : '请输入规格型号'"/>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item prop="machinePlatform" label="整机平台">
            <el-autocomplete
                v-model.trim="repairRegistration.machinePlatform"
                style="width: 100%"
                clearable
                :fetch-suggestions="((queryString, cb) => {querySearch(queryString, cb, machinePlatforms)})"
                :placeholder="disabled ? '' : '请输入整机平台'"/>
          </el-form-item>
          <el-form-item prop="voltageLevel" label="电压等级">
            <el-autocomplete
                v-model.trim="repairRegistration.voltageLevel"
                style="width: 100%"
                clearable
                :fetch-suggestions="((queryString, cb) => {querySearch(queryString, cb, voltageLevels)})"
                :placeholder="disabled ? '' : '请输入电压等级'"/>
          </el-form-item>
          <el-form-item prop="power" label="功率">
            <el-input v-model.trim="repairRegistration.power" :placeholder="disabled ? '' : '请输入功率'" clearable>
              <template slot="append">kw</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item prop="receiveProductDate" label="实收生产日期">
            <el-date-picker
                v-model="repairRegistration.receiveProductDate"
                value-format="yyyy-MM-dd"
                type="date"
                clearable
                style="width: 100%"
                :placeholder="disabled ? '' : '选择实收生产日期'"/>
          </el-form-item>
          <el-form-item prop="receiveDeliveryDate" label="实收发货日期">
            <el-date-picker
                v-model="repairRegistration.receiveDeliveryDate"
                value-format="yyyy-MM-dd"
                type="date"
                clearable
                style="width: 100%"
                :placeholder="disabled ? '' : '选择实收发货日期'"
                @change="getSaleTime(repairRegistration.demandAfterSaleTime, repairRegistration.receiveDeliveryDate, 'receiveSaleTime')"/>
          </el-form-item>
          <el-form-item prop="receiveSaleTime" label="实收售出时长">
            <el-input
                v-model.number="repairRegistration.receiveSaleTime"
                :placeholder="disabled ? '' : '请输入实收售出时长'"
                type="number"
                min="0">
              <template slot="append">月</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item prop="receiveAfterSaleExpired" label="实收售后过保">
            <el-switch
                v-model="repairRegistration.receiveAfterSaleExpired"
                :active-value="true"
                :inactive-value="false"
                active-text="是"
                inactive-text="否"/>
          </el-form-item>
          <el-form-item prop="pgCard" label="PG卡">
            <el-autocomplete
                v-model.trim="repairRegistration.pgCard"
                style="width: 100%"
                clearable
                :fetch-suggestions="((queryString, cb) => {querySearch(queryString, cb, pgCards)})"
                :placeholder="disabled ? '' : '请输入PG卡'"/>
          </el-form-item>
          <el-form-item prop="powerOnTime" label="上电时间">
            <el-input
                v-model.number="repairRegistration.powerOnTime"
                :placeholder="disabled ? '' : '请输入上电时间'"
                @input="limitInput($event, 'powerOnTime')">
              <template slot="append">min</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item prop="runTime" label="运行时间">
            <el-input
                v-model.number="repairRegistration.runTime"
                :placeholder="disabled ? '' : '请输入运行时间'"
                @input="limitInput($event, 'runTime')">
              <template slot="append">min</template>
            </el-input>
          </el-form-item>
          <el-form-item prop="radiatorTemperature" label="散热器温度">
            <el-input
                v-model.number="repairRegistration.radiatorTemperature"
                :placeholder="disabled ? '' : '请输入散热器温度'"
                @input="limitInput($event, 'radiatorTemperature')"/>
          </el-form-item>
          <el-form-item prop="faultCode" label="故障代码">
            <el-input
                v-model.trim="repairRegistration.faultCode"
                :placeholder="disabled ? '' : '请输入故障代码'"
                clearable/>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item prop="moduleBranding" label="模块品牌">
            <el-autocomplete
                v-model.trim="repairRegistration.moduleBranding"
                style="width: 100%"
                clearable
                :fetch-suggestions="((queryString, cb) => {querySearch(queryString, cb, moduleBrandings)})"
                :placeholder="disabled ? '' : '请输入块品牌'"/>
          </el-form-item>
          <el-form-item prop="originProgram" label="原程序">
            <el-input v-model.trim="repairRegistration.originProgram" :placeholder="disabled ? '' : '请输入原程序'" clearable/>
          </el-form-item>
          <el-form-item prop="newProgram" label="新程序">
            <el-input v-model.trim="repairRegistration.newProgram" :placeholder="disabled ? '' : '请输入新程序'" clearable/>
          </el-form-item>
        </div>
        <el-form-item prop="missingParts" label="缺件信息">
          <el-input
              v-model="repairRegistration.missingParts"
              :placeholder="disabled ? '' : '请输入缺件信息'"
              type="textarea"
              autosize
              show-word-limit
              maxlength="200"/>
        </el-form-item>
        <el-table
            :data="repairRegistration.originPartList"
            border
            style="width: 95%; margin-left: 3%">
          <el-table-column
              type="index"
              align="center"
              label="序号"
              width="50px"/>
          <el-table-column
              prop="originPartSn"
              align="center"
              label="原部件条码"
              width="150px">
            <template v-slot="scope">
              <el-input v-model.trim="scope.row.originPartSn" @change="getBySnOriginPart(scope.row.originPartSn, scope.$index)"/>
            </template>
          </el-table-column>
          <el-table-column
              prop="originPartMaterialNo"
              align="center"
              label="原部件物料号"
              width="100px">
            <template v-slot="scope">
              <el-input v-model.trim="scope.row.originPartMaterialNo" @change="getOriginMaterialName(scope.row.originPartMaterialNo, scope.$index)"/>
            </template>
          </el-table-column>
          <el-table-column
              prop="originPartMaterialName"
              label="原部件物料描述"
              width="250px"
              show-overflow-tooltip/>
          <el-table-column
              prop="originPartQuantity"
              align="center"
              label="原部件数量"
              width="100px">
            <template v-slot="scope">
              <el-input v-model.number="scope.row.originPartQuantity" type="number" min="1"/>
            </template>
          </el-table-column>
          <el-table-column
              prop="cost"
              align="center"
              label="部件费"
              width="70px">
            <template v-slot="scope">
              <el-input
                  v-model.number="scope.row.cost"
                  @input="limitOriginPartInput(scope.$index, $event, 'cost')"
                  @change="partCostChange"/>
            </template>
          </el-table-column>
          <el-table-column
              prop="originPartInfo"
              align="center"
              label="部件信息">
            <template v-slot="scope">
              <el-autocomplete
                  v-model.trim="scope.row.originPartInfo"
                  style="width: 100%"
                  clearable
                  :fetch-suggestions="((queryString, cb) => {querySearch(queryString, cb, originPartInfos)})"/>
            </template>
          </el-table-column>
          <el-table-column
              v-if="!disabled"
              align="center"
              fixed="right"
              width="140px">
            <template #header>
              <el-button type="text" @click="handleRowAddOrigin">+ 新增行</el-button>
            </template>
            <template v-slot="scope">
              <el-button type="text" @click="handleRowDelete(scope.$index, repairRegistration.originPartList)">删除</el-button>
              <el-button type="text" :disabled="scope.$index === 0" @click="handleRowUp(scope.row, scope.$index, repairRegistration.originPartList)">上移</el-button>
              <el-button type="text" :disabled="scope.$index === repairRegistration.originPartList.length - 1" @click="handleRowDown(scope.row, scope.$index, repairRegistration.originPartList)">下移</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-form-item prop="inspectionResult" label="检测现象" style="margin-top: 10px">
          <el-autocomplete
              v-model.trim="repairRegistration.inspectionPhenomena"
              style="width: 100%"
              clearable
              :placeholder="disabled ? '' : '请输入检查现象'"/>
        </el-form-item>
        <el-form-item prop="inspectionResult" label="检测结果" style="margin-top: 10px">
          <el-autocomplete
              v-model.trim="repairRegistration.inspectionResult"
              style="width: 100%"
              clearable
              :fetch-suggestions="((queryString, cb) => {querySearch(queryString, cb, inspectionResults)})"
              :placeholder="disabled ? '' : '请输入检测结果'"/>
        </el-form-item>
        <el-form-item prop="solution" label="处理方法">
          <el-autocomplete
              v-model.trim="repairRegistration.solution"
              style="width: 100%"
              clearable
              :fetch-suggestions="((queryString, cb) => {querySearch(queryString, cb, solutions)})"
              :placeholder="disabled ? '' : '请输入处理方法'"/>
        </el-form-item>
        <el-form-item prop="faultType" label="故障模块分类">
          <el-select v-model="repairRegistration.faultType" multiple :placeholder="disabled ? '' : '请选择故障模块分类'">
            <el-option value="整流回路"/>
            <el-option value="充电回路"/>
            <el-option value="母线电容"/>
            <el-option value="驱动回路"/>
            <el-option value="制动回路"/>
            <el-option value="开关电源"/>
            <el-option value="主控回路"/>
            <el-option value="驱动控制板"/>
            <el-option value="显示板回路"/>
            <el-option value="电流电压检测回路"/>
            <el-option value="PG卡"/>
            <el-option value="线束"/>
            <el-option value="接插件"/>
            <el-option value="短接片"/>
            <el-option value="IO接口"/>
            <el-option value="主接线端子"/>
            <el-option value="整改"/>
            <el-option value="缺件"/>
            <el-option value="参数问题"/>
            <el-option value="程序问题"/>
            <el-option value="版本过旧"/>
            <el-option value="制成不良"/>
            <el-option value="原材料不良"/>
            <el-option value="进水氧化腐蚀"/>
            <el-option value="客户自行维修"/>
            <el-option value="商务原因"/>
            <el-option value="外力损坏"/>
          </el-select>
        </el-form-item>
        <el-form-item label="电机问题类型" prop="problemType">
          <!--          <el-cascader-->
          <!--              :key="changedKey"-->
          <!--              v-model="repairRegistration.problemTypes"-->
          <!--              :options="problemTypeTree"-->
          <!--              :props="{value: 'label', checkStrictly: true, multiple: true}"-->
          <!--              style="width: 100%"-->
          <!--              placeholder="请选择电机问题类型"-->
          <!--              @change="problemTypeChange"/>-->
        </el-form-item>
      </div>
      <div v-else>
        <!--        <div class="vm-separate">-->
        <!--          <el-form-item prop="receiveSn" label="实收序列号">-->
        <!--            <el-input-->
        <!--                v-model.trim="repairRegistration.receiveSn"-->
        <!--                :placeholder="disabled ? '' : '请输入实收序列号'"-->
        <!--                clearable/>-->
        <!--          </el-form-item>-->
        <!--          <el-form-item prop="receiveMaterialNo" label="实收物料号">-->
        <!--            <el-input-->
        <!--                v-model.trim="repairRegistration.receiveMaterialNo"-->
        <!--                :placeholder="disabled ? '' : '请输入实收物料号'"-->
        <!--                clearable-->
        <!--                @change="getMaterialName(repairRegistration.receiveMaterialNo, 'receiveMaterialName')"/>-->
        <!--          </el-form-item>-->
        <!--          <el-form-item prop="model" label="规格型号">-->
        <!--            <el-autocomplete-->
        <!--                v-model.trim="repairRegistration.model"-->
        <!--                style="width: 100%"-->
        <!--                clearable-->
        <!--                :fetch-suggestions="((queryString, cb) => {querySearch(queryString, cb, models)})"-->
        <!--                :placeholder="disabled ? '' : '请输入规格型号'"/>-->
        <!--          </el-form-item>-->
        <!--        </div>-->
        <div class="vm-separate">
          <el-form-item prop="hardwareVersion" label="硬件版本">
            <el-input
                v-model.trim="repairRegistration.hardwareVersion"
                :placeholder="disabled ? '' : '请输入'"
                clearable/>
          </el-form-item>
          <el-form-item prop="barCodeNo" label="条码号">
            <el-input
                v-model.trim="repairRegistration.barCodeNo"
                :placeholder="disabled ? '' : '请输入'"
                clearable/>
          </el-form-item>
          <el-form-item prop="receiveProductDate" label="实收生产日期">
            <el-date-picker
                v-model="repairRegistration.receiveProductDate"
                value-format="yyyy-MM-dd"
                type="date"
                clearable
                style="width: 100%"
                :placeholder="disabled ? '' : '选择实收生产日期'"/>
          </el-form-item>
        </div>
        <el-form-item prop="inspectionResult" label="外观检测" style="margin-top: 10px">
          <el-autocomplete
              v-model.trim="repairRegistration.inspectionPhenomena"
              style="width: 100%"
              clearable
              :placeholder="disabled ? '' : '请输入检查现象'"/>
        </el-form-item>
        <el-form-item prop="inspectionResult" label="检测现象" style="margin-top: 10px">
          <el-autocomplete
              v-model.trim="repairRegistration.inspectionPhenomena"
              style="width: 100%"
              clearable
              :placeholder="disabled ? '' : '请输入检查现象'"/>
        </el-form-item>
        <el-form-item prop="inspectionResult" label="检测结果" style="margin-top: 10px">
          <el-autocomplete
              v-model.trim="repairRegistration.inspectionResult"
              style="width: 100%"
              clearable
              :fetch-suggestions="((queryString, cb) => {querySearch(queryString, cb, inspectionResults)})"
              :placeholder="disabled ? '' : '请输入检测结果'"/>
        </el-form-item>
        <el-form-item prop="solution" label="处理方法">
          <el-autocomplete
              v-model.trim="repairRegistration.solution"
              style="width: 100%"
              clearable
              :fetch-suggestions="((queryString, cb) => {querySearch(queryString, cb, solutions)})"
              :placeholder="disabled ? '' : '请输入处理方法'"/>
        </el-form-item>
      </div>
      <div class="title" style="margin-top: 10px">费用</div>
      <div>
        <el-form-item prop="causeInvestigation" label="原因分析">
          <el-autocomplete
              v-model.trim="repairRegistration.causeInvestigation"
              style="width: 100%"
              clearable
              :fetch-suggestions="((queryString, cb) => {querySearch(queryString, cb, causeInvestigations)})"
              :placeholder="disabled ? '' : '请输入原因分析'"/>
        </el-form-item>
        <div class="vm-separate">
          <el-form-item prop="responsibleDecision" label="责任判定">
            <el-autocomplete
                v-model.trim="repairRegistration.responsibleDecision"
                style="width: 100%"
                clearable
                :fetch-suggestions="((queryString, cb) => {querySearch(queryString, cb, responsibleDecisions)})"
                :placeholder="disabled ? '' : '请输入责任判定'"/>
          </el-form-item>
          <el-form-item prop="reasonForCharge" label="收费原因">
            <el-autocomplete
                v-model.trim="repairRegistration.reasonForCharge"
                style="width: 100%"
                clearable
                :fetch-suggestions="((queryString, cb) => {querySearch(queryString, cb, reasonForCharges)})"
                :placeholder="disabled ? '' : '请输入收费原因'"/>
          </el-form-item>
          <el-form-item prop="laborTime" label="工时">
            <el-autocomplete
                v-model.number="repairRegistration.laborTime"
                style="width: 100%"
                clearable
                :fetch-suggestions="((queryString, cb) => {querySearchInt(queryString, cb, laborTimes)})"
                :placeholder="disabled ? '' : '请输入工时'">
              <template slot="append">min</template>
            </el-autocomplete>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item prop="partCosts" label="部件费用">
            <el-input
                v-model.number="repairRegistration.partCosts"
                :placeholder="disabled ? '' : '请输入部件费用'"
                @input="limitInput($event, 'partCosts')"
                @change="costsChange"/>
          </el-form-item>
          <el-form-item prop="materialCosts" label="材料费用">
            <el-input
                v-model.number="repairRegistration.materialCosts"
                :placeholder="disabled ? '' : '请输入材料费用'"
                @input="limitInput($event, 'materialCosts')"
                @change="costsChange"/>
          </el-form-item>
          <el-form-item prop="otherCosts" label="其他费用">
            <el-input
                v-model.number="repairRegistration.otherCosts"
                :placeholder="disabled ? '' : '请输入其他费用'"
                @input="limitInput($event, 'otherCosts')"
                @change="costsChange"/>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item prop="laborCosts" label="工时费用">
            <el-input
                v-model.number="repairRegistration.laborCosts"
                :placeholder="disabled ? '' : '请输入工时费用'"
                @input="limitInput($event, 'laborCosts')"
                @change="costsChange"/>
          </el-form-item>
          <el-form-item prop="reportCosts" label="报告费用">
            <el-input
                v-model.number="repairRegistration.reportCosts"
                :placeholder="disabled ? '' : '请输入报告费用'"
                @input="limitInput($event, 'reportCosts')"
                @change="costsChange"/>
          </el-form-item>
          <el-form-item prop="totalCosts" label="总费用">
            <el-input v-model="repairRegistration.totalCosts" :disabled="repairRegistration.partCosts === '' && repairRegistration.otherCosts === '' && repairRegistration.materialCosts === '' && repairRegistration.laborCosts === '' && repairRegistration.reportCosts === ''" readonly/>
          </el-form-item>
        </div>
        <el-form-item prop="note" label="备注">
          <el-input
              v-model.trim="repairRegistration.note"
              type="textarea"
              autosize
              :placeholder="disabled ? '' : '请输入备注'"
              clearable
              maxlength="500"
              show-word-limit/>
        </el-form-item>
      </div>
      <div class="title">结论</div>
      <div>
        <div class="vm-separate">
          <el-form-item prop="repairStatus" label="维修状态" :rules="$rule.notNull">
            <el-autocomplete
                v-model.trim="repairRegistration.repairStatus"
                style="width: 100%"
                clearable
                :fetch-suggestions="((queryString, cb) => {querySearch(queryString, cb, repairStatuses)})"
                :placeholder="disabled ? '' : '请输入维修状态'"/>
          </el-form-item>
          <el-form-item prop="repairDate" label="维修日期" :rules="$rule.notNull">
            <el-date-picker
                v-model="repairRegistration.repairDate"
                value-format="yyyy-MM-dd"
                type="date"
                clearable
                style="width: 100%"
                :placeholder="disabled ? '' : '选择维修日期'"/>
          </el-form-item>
          <el-form-item prop="expiredDeliveryDate" label="预计发货日期">
            <el-date-picker
                v-model="repairRegistration.expiredDeliveryDate"
                value-format="yyyy-MM-dd"
                type="date"
                clearable
                style="width: 100%"
                :placeholder="disabled ? '' : '选择预计发货日期'"/>
          </el-form-item>
        </div>
        <el-form-item prop="attachmentNote" label="附件备注">
          <el-input
              v-model.trim="repairRegistration.attachmentNote"
              type="textarea"
              autosize
              :placeholder="disabled ? '' : '请输入附件备注'"
              clearable
              maxlength="500"
              show-word-limit/>
        </el-form-item>
      </div>
    </el-form>
    <div class="title" style="margin-top: 10px">附件</div>
    <div style="height: 28px">
      <el-upload
          action=""
          multiple
          :http-request="submitUpload"
          :show-file-list="false"
          :disabled="uploadLoading"
          style="display: inline-block; float: left;margin-right: 5px">
        <el-button type="primary" plain>
          <i class="el-icon-upload el-icon--right"/>
          附件上传
        </el-button>
      </el-upload>
      <el-button type="primary" @click="capture">拍照</el-button>
      <el-button v-if="devices.length > 1" type="success" @click="switchCamera">切换摄像头</el-button>
    </div>
    <div>
      <div style="display: flex;">
        <video ref="video" style="flex: 1" autoplay/>
        <canvas ref="canvas" style="flex: 1;margin-left: 10px"/>
      </div>
    </div>
    <el-table
        :data="repairRegistration.attachments"
        border
        stripe>
      <el-table-column type="index" align="center" label="行号"/>
      <el-table-column prop="fileName" align="center" label="图片">
        <template slot-scope="scope">
          <el-image
              style="width: 50px; height: 50px;margin-right: 10px"
              :src="scope.row.imgUrl"
              :preview-src-list="imgUrls"/>
        </template>
      </el-table-column>
      <el-table-column prop="fileName" align="center" label="附件描述"/>
      <el-table-column prop="note" align="center" label="附件类别" width="200px">
        <template v-slot="scope">
          <el-select v-model="scope.row.note" :disabled="disabled" :placeholder="disabled ? '' : '请选择附件类别'">
            <el-option value="照片"/>
            <el-option value="数据"/>
            <el-option value="报告"/>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="180px">
        <template v-slot="scope">
          <el-button type="primary" @click="download(scope.row)">下载</el-button>
          <el-button v-if="!disabled" type="danger" @click="fileDelete(scope.$index, 1)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
    <customer-select ref="customerSelect" @select="customerSelect"/>
    <!--    <quality-reg-select ref="qualityRegSelect" @select="qualityRegSelect"/>-->
  </el-dialog>
</template>

<script>
  import CustomerSelect from "@/views/information/Customer/CustomerSelect.vue";
  import loginUtil from "@/util/loginUtil";
  import moment from "moment";
  // import QualityRegSelect from "@/views/Quality/QualityRegTable/QualityRegSelect.vue";
  export default {
    name: "RepairRegistrationEdit",
    components: {CustomerSelect},
    data() {
      return {
        devices: [],
        currentDeviceId: null,
        stream: null,
        capturedFile: null,

        
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        uploadLoading: false,
        disabled: false,
        showVideo: true,
        changedKey: 0,
        problemTypeTree: [],
        fileList: [],
        imgUrls: [],
        models: [
          {value: "AS170"},
          {value: "AS180"},
          {value: "AS300"},
          {value: "AS330"},
          {value: "AS320"},
          {value: "AS400"},
          {value: "AS350"},
          {value: "AS360"},
          {value: "AS380"},
          {value: "AS380C"},
          {value: "AS380D"},
          {value: "AS380S"},
          {value: "AS450"},
          {value: "AS500"},
          {value: "AS530"},
          {value: "AS550"},
          {value: "AS560"},
          {value: "AS570"},
          {value: "AS571"},
          {value: "AS620"},
          {value: "AS700"},
          {value: "AS720"},
        ],
        machinePlatforms: [
          {value: "AS380"},
          {value: "AS380S"},
          {value: "柔性平台"},
        ],
        voltageLevels: [
          {value: "AC200V"},
          {value: "AC400V"},
          {value: "AC690V"},
          {value: "高压产品"},
        ],
        pgCards: [
          {value: "AS.L06/U"},
          {value: "AS.T024"},
          {value: "ETU-BA"},
          {value: "ETU-BB"},
          {value: "AS.L06/B1"},
          {value: "AS.L06/D"},
          {value: "AS.L06/L"},
          {value: "AS.L06/W"},
          {value: "AS.L06/P"},
          {value: "AS.L06/V"},
          {value: "AS.L06/W"},
          {value: "AS.T025"},
          {value: "AS.T041"},
        ],
        moduleBrandings: [
          {value: "安建"},
          {value: "富士"},
          {value: "林众"},
          {value: "三菱"},
          {value: "威科"},
          {value: "仙童"},
          {value: "英飞凌"},
          {value: "赛米控"},
          {value: "士兰微"},
          {value: "比亚迪"},
        ],
        inspectionResults: [
          {value: "检查正常"},
          {value: "进水氧化腐蚀"},
          {value: "异物污损"},
          {value: "不通电"},
        ],
        solutions: [
          {value: "修复-更换外壳一套"},
          {value: "修复-更换不良配件"},
          {value: "修复-拆解外壳保留板卡"},
          {value: "报废-整机不可修复"},
          {value: "参数复位-检测正常"},
          {value: "报废-拆解"},
          {value: "修复-翻新"},
          {value: "报废-版本淘汰"},
          {value: "报废-产品老化"},
          {value: "原路反回-不可修复"},
          {value: "原路反回-客户不修"},
          {value: "原路反回-不予维修"},
        ],
        causeInvestigations: [
          {value: "A:使用过应力，过流、过压"},
          {value: "B:静电/浪涌/雷击失效"},
          {value: "C:现场使用不当（接线/配置/软件/硬件错误等）"},
          {value: "D:现场使用环境恶劣（PCB浸水、受潮、产生氧化）"},
          {value: "E:元器件、PCB受外力损坏"},
          {value: "F:制造缺陷（焊接/装配问题）"},
          {value: "G:元器件存在质量问题"},
          {value: "H:元器件老化、性能退化"},
          {value: "I:客户自行维修"},
          {value: "J:商务、订单（错发/错配/客户要求更换）"},
          {value: "K:硬件测试无问题，需进一步分析"},
          {value: "L:无法判断"},
        ],
        responsibleDecisions: [
          {value: "a:研发部"},
          {value: "b:股份工厂"},
          {value: "c:供应商责任"},
          {value: "d:战略采购部"},
          {value: "e:SQE专业线"},
          {value: "f:销售部"},
          {value: "g:发运部"},
          {value: "h工艺部"},
          {value: "i:计划部"},
          {value: "j:采购部"},
          {value: "k:仓储部"},
          {value: "l:生产部"},
          {value: "m:订单管理部"},
          {value: "n:产品管理部"},
          {value: "o:质量部"},
          {value: "p:售后服务部"},
          {value: "q:客户责任"},
          {value: "r:其他"},
        ],
        reasonForCharges: [
          {value: "使用不当"},
          {value: "过保修期"},
          {value: "客户需求"},
          {value: "客户责任"},
          {value: "OEM代工费"},
          {value: "保外原因"},
          {value: "保内原因"},
          {value: "翻新"},
          {value: "缺件"},
        ],
        repairStatuses: [
          {value: "已维修"},
          {value: "维修中"},
          {value: "报价中"},
          {value: "负载中"},
          {value: "报废"},
          {value: "研发分析中"},
          {value: "不维修"},
        ],
        partModels: [
          {value: "AS.L09-J-A1"},
          {value: "AS.T024"},
          {value: "AS.T029"},
          {value: "AS.T029-A1"},
          {value: "AS.T030"},
          {value: "AS.T030/A"},
          {value: "AS.L01/J"},
          {value: "AS.L01/K"},
          {value: "AS.L06/U"},
          {value: "AS.L06/V"},
          {value: "AS.L06/W"},
          {value: "AS.L09/B1"},
          {value: "AS.L09/C1"},
          {value: "AS.L09/G1"},
          {value: "AS.L09/H1"},
          {value: "AS.L09/I1"},
          {value: "AS.L09/J"},
          {value: "AS.L09-J-A1"},
          {value: "AS.L09/K1"},
          {value: "AS.L09-M1"},
          {value: "AS.L09/O"},
          {value: "AS.L09/Q"},
          {value: "AS.L09/Q-1"},
          {value: "AS.L09/S"},
          {value: "AS.L09-T1"},
          {value: "AS.L09/U"},
          {value: "AS.L09/V"},
          {value: "AS.L09-V1"},
          {value: "AS.L09/W"},
          {value: "AS.L09-W1"},
          {value: "AS.L09/X"},
        ],
        inspectionMethods: [
          {value: "检查正常"},
          {value: "检查正常良品备件"},
          {value: "无显示"},
          {value: "显示异常"},
          {value: "通讯异常"},
          {value: "异物污损"},
          {value: "主回路无输出"},
          {value: "进水氧化腐蚀"},
          {value: "目视元件烧坏"},
          {value: "目视元件破损"},
          {value: "IO口输入异常"},
          {value: "IO口输出异常"},
          {value: "3.3V电压异常"},
          {value: "5.0V电压异常"},
          {value: "24V电压异常"},
        ],
        electricNetworks: [
          {value: "整流回路"},
          {value: "充电回路"},
          {value: "母线电容"},
          {value: "开关电源"},
          {value: "逆变驱动回路"},
          {value: "驱动控制回路"},
          {value: "主控回路"},
          {value: "电流检测回路"},
          {value: "温度检测回路"},
          {value: "母线检测回路"},
          {value: "功率检测回路"},
          {value: "主回路输出"},
          {value: "IO输入回路"},
          {value: "IO输出回路"},
          {value: "通讯-CAN"},
          {value: "通讯-485"},
          {value: "通讯-422"},
          {value: "通讯-服务器"},
          {value: "通讯-4G"},
          {value: "显示回路"},
          {value: "风扇回路"},
          {value: "主接线端子"},
          {value: "接插件"},
          {value: "线束"},
        ],
        failureModes: [
          {value: "功能失效"},
          {value: "元件击穿"},
          {value: "氧化腐蚀"},
          {value: "元件烧坏"},
          {value: "元件焊盘烧坏"},
          {value: "元件线路烧坏"},
          {value: "元件错件"},
          {value: "元件缺件"},
          {value: "元件变形"},
          {value: "元件破损"},
          {value: "元件鼓包漏液"},
          {value: "元件焊盘破损"},
          {value: "元件精度偏差"},
          {value: "PCB线路破损"},
          {value: "焊接不良-虚焊断路"},
          {value: "焊接不良-翘脚断路"},
          {value: "焊接不良-连锡短路"},
          {value: "焊接不良-元件浮高"},
          {value: "焊接不良-进锡短路"},
          {value: "压线断路"},
          {value: "压线破皮短路"},
          {value: "原材料断线"},
          {value: "缺固定螺丝"},
          {value: "螺丝滑牙"},
          {value: "螺丝堵头"},
          {value: "螺母滑牙"},
          {value: "螺柱滑牙"},
          {value: "接触不良"},
          {value: "进胶-接触不良"},
          {value: "MCU无程序"},
          {value: "MCU程序缺陷"},
          {value: "MCU程序与需求不符"},
          {value: "MCU程序与标贴不符"},
        ],
        repairMethods: [
          {value: "无处理"},
          {value: "更换元件"},
          {value: "不可修复"},
          {value: "器件整改"},
          {value: "重新焊接"},
          {value: "重新组装"},
          {value: "烧录程序"},
          {value: "程序升级"},
          {value: "软件解锁"},
          {value: "复位软件参数"},
          {value: "擦除数据EEPROM"},
        ],
        repairResults: [
          {value: "修复"},
          {value: "报废-不可修复"},
          {value: "报废-版本淘汰"},
          {value: "报废-产品老化"},
          {value: "报废—原路反回"},
          {value: "不予维修-反回"},
        ],
        originPartInfos: [
          {value: "检测正常"},
          {value: "板卡报废"},
          {value: "拆解板卡"},
          {value: "替换部件（部件条码）"},
          {value: "实收部件（部件条码）"},
          {value: "氧化腐蚀"},
          {value: "外力破损"},
          {value: "异物入侵"},
        ],
        hardwareVersions: [
          {value: "1"},
          {value: "2"},
          {value: "3"},
          {value: "4"},
          {value: "5"},
          {value: "6"},
          {value: "7"},
          {value: "8"},
          {value: "9"},
          {value: "10"},
          {value: "11"},
        ],
        laborTimes: [
          {value: "5"},
          {value: "10"},
          {value: "15"},
          {value: "20"},
          {value: "25"},
          {value: "30"},
          {value: "35"},
          {value: "40"},
          {value: "45"},
          {value: "50"},
          {value: "55"},
          {value: "60"},
        ],
        demandMaterialNos: [],
        repairRegistration: {
          id: "",
          billNo: "",
          productNo: "",
          projectName: "",
          afterSaleType: "",
          afterSaleOrderNo: "",
          qualityRegistrationNo: "",
          department: "",
          demandNode: "",
          partType: "板卡",
          customerId: "",
          customerName: "",
          outerCustomer: "",
          customerOrderNo: "",
          demandSn: "",
          demandMaterialNo: "",
          demandMaterialName: "",
          quantity: 1,
          productDate: "",
          deliveryDate: "",
          demandAfterSaleTime: "",
          saleTime: "",
          afterSaleExpired: false,
          needQualitySurvey: false,
          siteDesc: "",
          receiveSn: "",
          receiveMaterialNo: "",
          receiveMaterialName: "",
          model: "",
          machinePlatform: "",
          voltageLevel: "",
          power: "",
          receiveProductDate: "",
          receiveDeliveryDate: "",
          receiveSaleTime: "",
          receiveAfterSaleExpired: false,
          pgCard: "",
          powerOnTime: "",
          runTime: "",
          radiatorTemperature: "",
          faultCode: "",
          moduleBranding: "",
          originProgram: "",
          newProgram: "",
          missingParts: "",
          inspectionPhenomena: "",
          inspectionResult: "",
          solution: "",
          faultType: "",
          problemType: "",
          causeInvestigation: "",
          responsibleDecision: "",
          reasonForCharge: "",
          partCosts: "",
          materialCosts: "",
          otherCosts: "",
          laborTime: "",
          laborCosts: "",
          reportCosts: "",
          totalCosts: "",
          note: "",
          repairStatus: "",
          repairDate: "",
          expiredDeliveryDate: "",
          newMachineSn: "",
          newMaterialNo: "",
          newMaterialName: "",
          attachmentNote: "",
          hardwareVersion: "",
          barCodeNo: "",
          inkJetCodeNo: "",
          partList: [],
          originPartList: [],
          attachments: [],
          problemTypes: [],
        },
      };
    },
    async mounted() {
      await this.initializeCamera();
    },
    beforeUnmount() {
      this.stopCamera();
    },
    methods: {
      open(id, disabled) {
        this.repairRegistration.id = id;
        this.dialogVisible = true;
        if (disabled) {
          this.disabled = true;
        }
        // this.getProblemTypeTree();
        if (id > 0) {
          this.getData();
        } else {
          this.repairRegistration.creatorName = loginUtil.getName();
          let date = moment();
          this.repairRegistration.repairDate = date.format("YYYY-MM-DD");
        }
      },
      async initializeCamera(deviceId) {
        try {
          const constraints = {
            video: deviceId ? { deviceId: { exact: deviceId } } : true,
          };

          // 获取视频流
          const stream = await navigator.mediaDevices.getUserMedia(constraints);
          this.stream = stream;

          // 获取可用摄像头设备
          if (!deviceId) {
            const devices = await navigator.mediaDevices.enumerateDevices();
            this.devices = devices.filter(device => device.kind === "videoinput");
          }

          // 显示视频流
          this.$refs.video.srcObject = stream;
          this.currentDeviceId = stream.getVideoTracks()[0].getSettings().deviceId;
        } catch (error) {
          console.error("摄像头访问失败:", error);
        }
      },
      // 上传图片
      capture() {
        const video = this.$refs.video;
        const canvas = this.$refs.canvas;
        const context = canvas.getContext("2d");

        // 设置 canvas 尺寸与视频一致
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        canvas.toBlob((blob) => {
          if (!blob) return;

          // 生成文件名（如 snapshot-时间戳.jpg）
          const fileName = `snapshot-${Date.now()}.jpg`;
          const file = new File([blob], fileName, { type: "image/png" });
          let params = {
            file: file,
          };
          this.submitUpload(params);
        }, "image/png", 0.9);
      },

      async switchCamera() {
        const currentIndex = this.devices.findIndex(
          d => d.deviceId === this.currentDeviceId
        );
        const newDevice = this.devices[(currentIndex + 1) % this.devices.length];

        this.stopCamera();
        await this.initializeCamera(newDevice.deviceId);
      },
      stopCamera() {
        if (this.stream) {
          this.stream.getTracks().forEach(track => track.stop());
        }
      },
      getData() {
        this.$http
          .get("basic", `repairRegistrations/${this.repairRegistration.id}`)
          .then(resp => {
            this.repairRegistration = resp;
            if (resp.faultType.length > 0) {
              this.repairRegistration.faultType = resp.faultType.split(",");
            }
            this.repairRegistration.problemTypes = this.repairRegistration.problemType ? this.repairRegistration.problemType.split(",") : [];
            this.repairRegistration.problemTypes = this.repairRegistration.problemTypes.map(item => item.split("/"));
            this.repairRegistration.attachments.forEach(row=>{
              if(row.filePath.includes("common")) {
                row.imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
                this.imgUrls.push(row.imgUrl);
              }else {
                row.imgUrl = "https://emes.stepelectric.com" + row.filePath;
                this.imgUrls.push(row.imgUrl);
              }
            });
          });
      },
      submitUpload(params) {
        console.log(params);
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/0", formData)
          .then((res) => {
            this.uploadLoading = false;
            // this.saveAttachments(res.data.attachments, 0);
            const fileInfo = res.data.attachments[0];
            console.log(fileInfo);
            this.repairRegistration.attachments.push({
              fileName: fileInfo.fileName,
              filePath: "/attached/file/" + fileInfo.filePath,
              note: "照片",
            });
            this.repairRegistration.attachments.forEach(row=>{
              if(row.filePath.includes("common")) {
                row.imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
                this.imgUrls.push(row.imgUrl);
              }else {
                row.imgUrl = "https://emes.stepelectric.com" + row.filePath;
                this.imgUrls.push(row.imgUrl);
                console.log(row.imgUrl);
              }
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      limitInput(value, name) {
        this.repairRegistration[name] = ("" + value)
          .replace(/[^\d^.]+/g, "")
          .replace(/^0+(\d)/, "$1")
          .replace(/^\./, "0.")
          .match(/^\d*(\.?\d{0,2})/g)[0] || "";
      },
      limitOriginPartInput(index, value, name) {
        this.repairRegistration.originPartList.at(index)[name] = ("" + value)
          .replace(/[^\d^.]+/g, "")
          .replace(/^0+(\d)/, "$1")
          .replace(/^\./, "0.")
          .match(/^\d*(\.?\d{0,2})/g)[0] || "";
      },
      partCostChange() {
        let totalCosts = 0;
        this.repairRegistration.originPartList.forEach(item => {
          if (item.cost !== "" && item.cost > 0) {
            totalCosts += Number(item.cost);
          }
        });
        this.repairRegistration.partList.forEach(item => {
          if (item.cost !== "" && item.cost > 0) {
            totalCosts += Number(item.cost);
          }
        });
        this.repairRegistration.partCosts = Number(totalCosts.toFixed(2));
        this.costsChange();
      },
      costsChange() {
        let totalCosts = 0;
        if (this.repairRegistration.partCosts != null && this.repairRegistration.partCosts > 0) {
          totalCosts += Number(this.repairRegistration.partCosts);
        }
        if (this.repairRegistration.materialCosts != null && this.repairRegistration.materialCosts > 0) {
          totalCosts += Number(this.repairRegistration.materialCosts);
        }
        if (this.repairRegistration.otherCosts != null && this.repairRegistration.otherCosts > 0) {
          totalCosts += Number(this.repairRegistration.otherCosts);
        }
        if (this.repairRegistration.laborCosts != null && this.repairRegistration.laborCosts > 0) {
          totalCosts += Number(this.repairRegistration.laborCosts);
        }
        if (this.repairRegistration.reportCosts != null && this.repairRegistration.reportCosts > 0) {
          totalCosts += Number(this.repairRegistration.reportCosts);
        }
        this.repairRegistration.totalCosts = Number(totalCosts.toFixed(2));
      },
      customerSelect(row) {
        this.repairRegistration.customerId = row.customerID;
        this.repairRegistration.customerName = row.customerName;
      },
      qualityRegSelect(row) {
        this.repairRegistration.qualityRegistrationNo = row.billNo;
      },
      getMaterialName(no, name) {
        if (no.length > 0) {
          let params = {
            no: no,
          };
          this.$http
            .get("basic", "baseMaterials/selectNameByNo", params)
            .then((res) => {
              if (res) {
                this.repairRegistration[name] = res;
              } else {
                this.repairRegistration[name] = "";
              }
            });
        } else {
          this.repairRegistration[name] = "";
        }
      },
      getOriginMaterialName(no, index) {
        if (no.length > 0) {
          let params = {
            no: no,
          };
          this.$http
            .get("basic", "baseMaterials/selectNameByNo", params)
            .then(res => {
              if (res) {
                this.repairRegistration.originPartList.at(index).originPartMaterialName = res;
              } else {
                this.repairRegistration.originPartList.at(index).originPartMaterialName = "";
              }
            });
        } else {
          this.repairRegistration.originPartList.at(index).originPartMaterialName = "";
        }
      },
      afterSaleOrderNoChange() {
        // if (this.repairRegistration.afterSaleOrderNo.length > 0 && this.repairRegistration.afterSaleOrderNo.startsWith("ED")) {
        //   let param = {
        //     billNo: this.repairRegistration.afterSaleOrderNo,
        //   };
        //   this.$http
        //     .get("basic", "emergencyDeliveryBills/no", param)
        //     .then(res => {
        //       if (res) {
        //         this.repairRegistration.department = "电机";
        //         this.repairRegistration.demandNode = "售后";
        //         this.repairRegistration.demandSn = res.productCode ? res.productCode.trim() : "";
        //         this.repairRegistration.customerId = res.customerId;
        //         this.repairRegistration.customerName = res.customerName;
        //         this.repairRegistration.siteDesc = res.note;
        //         this.repairRegistration.needQualitySurvey = res.isQualitySurvey;
        //         this.repairRegistration.afterSaleExpired = res.isExpired;
        //         this.repairRegistration.demandAfterSaleTime = res.createdTime ? res.createdTime.slice(0,10) : res.createdTime;
        //         res.details.forEach(item => {
        //           let param = {
        //             value: item.materialNo,
        //             desc: item.materialName,
        //             quantity: item.quantity,
        //           };
        //           this.demandMaterialNos.push(param);
        //         });
        //         if (this.demandMaterialNos.length === 1) {
        //           this.repairRegistration.demandMaterialNo = this.demandMaterialNos.at(0).value;
        //           this.repairRegistration.demandMaterialName = this.demandMaterialNos.at(0).desc;
        //           this.repairRegistration.quantity = this.demandMaterialNos.at(0).quantity;
        //         }
        //         this.getBySnDemand(this.repairRegistration.demandSn);
        //       }
        //     }).catch(() => {
        //       this.repairRegistration.department = "";
        //       this.repairRegistration.demandNode = "";
        //       this.repairRegistration.demandSn = "";
        //       this.repairRegistration.customerId = "";
        //       this.repairRegistration.customerName = "";
        //       this.repairRegistration.siteDesc = "";
        //       this.repairRegistration.needQualitySurvey = false;
        //       this.repairRegistration.afterSaleExpired = false;
        //       this.repairRegistration.demandAfterSaleTime = "";
        //       this.repairRegistration.deliveryDate = "";
        //       this.repairRegistration.productDate = "";
        //       this.repairRegistration.demandMaterialNo = "";
        //       this.repairRegistration.demandMaterialName = "";
        //       this.repairRegistration.quantity = 1;
        //       this.repairRegistration.saleTime = 0;
        //       this.demandMaterialNos = [];
        //     });
        // } else {
        //   this.repairRegistration.department = "";
        //   this.repairRegistration.demandNode = "";
        //   this.repairRegistration.demandSn = "";
        //   this.repairRegistration.customerId = "";
        //   this.repairRegistration.customerName = "";
        //   this.repairRegistration.siteDesc = "";
        //   this.repairRegistration.needQualitySurvey = false;
        //   this.repairRegistration.afterSaleExpired = false;
        //   this.repairRegistration.demandAfterSaleTime = "";
        //   this.repairRegistration.deliveryDate = "";
        //   this.repairRegistration.productDate = "";
        //   this.repairRegistration.demandMaterialNo = "";
        //   this.repairRegistration.demandMaterialName = "";
        //   this.repairRegistration.quantity = 1;
        //   this.repairRegistration.saleTime = 0;
        //   this.demandMaterialNos = [];
        // }
      },
      getSaleTime(d1, d2, target) {
        if (d1 !== "" && d2 !== "") {
          d1 = new Date(d1);
          d2 = new Date(d2);
          let diff = d1.getFullYear() * 12 + d1.getMonth() - d2.getFullYear() * 12 - d2.getMonth();
          this.repairRegistration[target] = diff < 0 ? 0 : diff;
        } else {
          this.repairRegistration[target] = 0;
        }
      },
      getBySnOriginPart(sn, index) {
        // if (sn.length > 0) {
        //   this.$http
        //     .get("basic", "snSerialNos/getBySn?sn=" + sn)
        //     .then(res => {
        //       this.repairRegistration.originPartList.at(index).originPartMaterialNo = res.materialNo;
        //       this.repairRegistration.originPartList.at(index).originPartMaterialName = res.materialDescription;
        //     }).catch(() => {
        //       this.repairRegistration.originPartList.at(index).originPartMaterialNo = "";
        //       this.repairRegistration.originPartList.at(index).originPartMaterialName = "";
        //     });
        // } else {
        //   this.repairRegistration.originPartList.at(index).originPartMaterialNo = "";
        //   this.repairRegistration.originPartList.at(index).originPartMaterialName = "";
        // }
      },
      getBySnPart(sn, index) {
        if (sn.length > 0) {
          this.$http
            .get("basic", "snSerialNos/getBySn?sn=" + sn)
            .then(res => {
              this.repairRegistration.partList.at(index).partMaterialNo = res.materialNo;
              this.repairRegistration.partList.at(index).partMaterialName = res.materialDescription;
            }).catch(() => {
              this.repairRegistration.partList.at(index).partMaterialNo = "";
              this.repairRegistration.partList.at(index).partMaterialName = "";
            });
          let param = {
            sn: sn,
          };
          this.$http
            .get("basic", "snSerialNos/time", param)
            .then(res => {
              this.repairRegistration.partList.at(index).productDate = res.productTime === null ? "" : res.productTime.slice(0, 10);
            }).catch(() => {
              this.repairRegistration.partList.at(index).productDate = "";
            });
        } else {
          this.repairRegistration.partList.at(index).partMaterialNo = "";
          this.repairRegistration.partList.at(index).partMaterialName = "";
          this.repairRegistration.partList.at(index).productDate = "";
        }
      },
      getBySnNew(sn) {
        if (sn.length > 0) {
          this.$http
            .get("basic", "snSerialNos/getBySn?sn=" + sn)
            .then(res => {
              this.repairRegistration.newMaterialNo = res.materialNo;
              this.repairRegistration.newMaterialName = res.materialDescription;
            }).catch(() => {
              this.repairRegistration.newMaterialNo = "";
              this.repairRegistration.newMaterialName = "";
            });
        } else {
          this.repairRegistration.newMaterialNo = "";
          this.repairRegistration.newMaterialName = "";
        }
      },
      querySearch(queryString, cb, list) {
        let items = list;
        let results = queryString ? items.filter(this.createFilter(queryString)) : items;
        cb(results);
      },
      createFilter(queryString) {
        return (item) => {
          return (item.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      querySearchInt(queryInt, cb, list) {
        let items = list;
        let results = queryInt ? items.filter(this.createFilterInt(queryInt)) : items;
        cb(results);
      },
      createFilterInt(queryInt) {
        return (item) => {
          return (item.value.toString().indexOf(queryInt) === 0);
        };
      },
      handleRowAddOrigin() {
        let originPart = {
          originPartSn: "",
          originPartMaterialNo: "",
          originPartMaterialName: "",
          cost: "",
          originPartInfo: "检测正常",
          originPartQuantity: 1,
        };
        this.repairRegistration.originPartList.push(originPart);
      },
      handleRowDelete(index, list) {
        list.splice(index, 1);
        if (list === this.repairRegistration.originPartList || list === this.repairRegistration.partList) {
          this.partCostChange();
        }
      },
      handleRowUp(row, index, list) {
        list.splice(index, 1);
        list.splice(index - 1, 0, row);
      },
      handleRowDown(row, index, list) {
        list.splice(index, 1);
        list.splice(index + 1, 0, row);
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            // this.repairRegistration.faultType = this.repairRegistration.faultType.toString();
            this.submitLoading = true;
            this.$http
              .save("basic", "repairRegistrations", this.repairRegistration)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSuccess(response, file) {
        this.$message.success("上传成功");
        file.path = response[0];
        let object = {
          fileName: file.path.originalName,
          filePath: file.path.fullPath,
        };
        this.repairRegistration.attachments.push(object);
      },
      handlerError(err) {
        alert(err);
      },
      fileDelete(index) {
        this.$confirm("确定要删除吗?","提示",{type:"warning"}).then(()=>{
          this.repairRegistration.attachments.splice(index, 1);
        });
      },
      download(row) {
        let data = {
          name: row.fileName,
          uuid: row.filePath,
        };
        this.$http
          .exportFile("basic", "file/download", data)
          .then((res) => {
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.config.params.name);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.downLoadLoading = false;
          }).catch(() => {
            this.downLoadLoading = false;
            this.$message.error("下载失败");
          });
      },
    },
  };
</script>
<style lang="scss" scoped>
.title {
  border-bottom: 1px solid #ddd;
  margin-bottom: 5px;
  padding-bottom: 5px;
  color: #000;
  font-size: 20px;
  font-weight: 700;
}
video, canvas {
  //width: 100%;
  max-width: 550px;
  display: block;
  margin: 10px 0;
}
</style>
